import { ProductLayout } from '@layout';
import {
    DashboardProductPage,
    AddProductPage,
    ListProductPage,
    NewsListPage,
    AddNewsPage,
    AgendaListPage,
    OrderListPage,
    OrderDetailsPage,
    CustomerListPage,
    SettingsProductPage,
    ListMemberValidationPage,
    AddFlashInfoPage,
    ListFlashInfoPage,
    EditMemberValidationPage,
    NotificationPage
} from '@pages';

import { RouteObject } from 'react-router-dom';
import { RedirectToLogin } from '../RedirectToLogin';
import { AdminProtectedRoute } from '../AdminProtectedRoute';

export const productRoutes = (isLogged: boolean | null | undefined): RouteObject[] => [
    {
        element: isLogged ? <ProductLayout /> : <RedirectToLogin />,
        path: '/products-management',
        children: [
            {
                path: '',
                element: <DashboardProductPage />
            },
            {
                path: 'products',
                children: [
                    {
                        path: '',
                        element: <ListProductPage />
                    },
                    {
                        path: 'add',
                        element: <AddProductPage />
                    },
                    {
                        path: ':id/edit',
                        element: <AddProductPage />
                    }
                ]
            },
            {
                path: 'orders',
                children: [
                    {
                        path: '',
                        element: <OrderListPage />
                    },
                    {
                        path: ':id/details',
                        element: <OrderDetailsPage />
                    }
                ]
            },
            {
                path: 'customers',
                children: [
                    {
                        path: '',
                        element: <CustomerListPage />
                    }
                ]
            },
            {
                path: 'news',
                children: [
                    {
                        path: '',
                        element: <NewsListPage />
                    },
                    {
                        path: 'add',
                        element: <AddNewsPage />
                    },
                    {
                        path: ':id/edit',
                        element: <AddNewsPage />
                    },
                    {
                        path: ':duplicateId/duplicate',
                        element: <AddNewsPage />
                    }
                ]
            },
            {
                path: 'agenda',
                element: <AgendaListPage />
            },
            {
                path: 'settings',
                element: (
                    <AdminProtectedRoute parentItem="product">
                        <SettingsProductPage />
                    </AdminProtectedRoute>
                ),
                children: [
                    {
                        path: ':tab'
                    }
                ]
            },
            {
                path: 'flash-infos',
                children: [
                    {
                        path: '',
                        element: <ListFlashInfoPage />
                    },
                    {
                        path: 'add',
                        element: <AddFlashInfoPage />
                    },
                    {
                        path: ':id/edit',
                        element: <AddFlashInfoPage />
                    }
                ]
            },
            {
                path: 'notifications',
                element: <NotificationPage />
            },
            {
                path: 'members-validation',
                children: [
                    {
                        path: '',
                        element: <ListMemberValidationPage />
                    },
                    {
                        path: 'add',
                        element: <EditMemberValidationPage />
                    },
                    {
                        path: ':id/edit',
                        element: <EditMemberValidationPage />
                    }
                ]
            }
        ]
    }
];
